<template>
	<layout>
		<textarea class="input textarea" v-model="val" @input="update(val)"/>
	</layout>
</template>

<script>
import layout from "./layout/input.vue";

export default {
	components: {layout},
	props: {
		value: {type: String, required: false}
	},
	data() {
		return {
			val: this.value
		}
	},
	methods: {
		update(value) {
			this.$emit("update", value);
		}
	}
};
</script>

<style lang="scss" scoped>
.input.textarea {
	min-height: 160px;
	padding: 12px 16px;
}
</style>
